import React from "react";

/**
 * Base button — visuals live in global.css (.btn / .btn-{variant} / .btn-sm)
 * so hover/active/disabled states are real CSS transitions, not inline
 * style juggling. `style` still merges on top for one-off layout tweaks.
 */
const Button = ({
  children,
  onClick,
  type = "button",
  disabled = false,
  variant = "primary",
  size = "md",
  icon: Icon,
  style,
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    className={`btn btn-${variant}${size === "sm" ? " btn-sm" : ""}`}
    style={style}
  >
    {Icon && <Icon size={size === "sm" ? 14 : 15} strokeWidth={2.25} />}
    {children}
  </button>
);

export default Button;
